module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm._.has(_vm.propsProposta, 'adiantamento') && _vm.propsProposta.adiantamento.length > 0) || (_vm.totais.projeto.total !== 0) || (_vm.table.items.length > 0)) ? _c('div', {
    staticClass: "box-body parcelasAdiantamento"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.formEditavel) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova parcela")]), _vm._v(" "), (_vm.table.items.length > 0) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "title": '<h5>Redistribuirá proporcionalmente, o total de R$ <span class=\'realce\'>' + _vm.totais.projeto.total + '</span> nas <span class=\'realce\'>' + _vm.table.items.length + '</span> parcelas abaixo</h5>'
    },
    on: {
      "click": _vm.distribuirValores
    }
  }, [_c('i', {
    staticClass: "fa fa-server",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distribuir")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.adiantamentos, function(a) {
        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), a.id)
      })) : _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.modificacaoLinha,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "parcela",
      fn: function(row) {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-between",
            "align-items": "center"
          }
        }, [_c('div', {
          staticStyle: {
            "width": "30px"
          }
        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
          staticClass: "pull-left"
        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Excluído")]) : _vm._e()]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "30px"
          }
        }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "50px"
          }
        }, [(_vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO' && (_vm.formEditavel && !_vm._.has(row.item, 'requisitado'))) ? _c('span', {
          staticClass: "botoesUpDown"
        }, [(row.index > 0) ? _c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
          }],
          staticClass: "fa fa-chevron-up",
          attrs: {
            "title": '<h5>Move essa parcela para Cima<br/>Será a ' + (row.item.parcela - 1) + 'ª parcela</h5>'
          },
          on: {
            "click": function($event) {
              return _vm.moverLinha(row, 'cima')
            }
          }
        }) : _vm._e(), _vm._v(" "), (row.index < _vm.table.items.length - 1) ? _c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
          }],
          staticClass: "fa fa-chevron-down",
          attrs: {
            "title": '<h5>Move essa parcela para Baixo<br/>Será a ' + (row.item.parcela + 1) + 'ª parcela</h5>'
          },
          on: {
            "click": function($event) {
              return _vm.moverLinha(row, 'baixo')
            }
          }
        }) : _vm._e()]) : _c('span', [_vm._v(" ")])])])]
      }
    }, {
      key: "origem",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.etiquetaOrigemRecurso(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm.etiquetaOrigemRecurso('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'origem.0', ''))) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "valor",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id])) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'valor.0', '0'))) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "requisitado",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
          }],
          attrs: {
            "title": '<h5>Valor liberado ou em análise para liberação</h5>'
          }
        }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                ")])]
      }
    }, {
      key: "percentual_comprovado",
      fn: function(row) {
        return [(row.value > 0) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
          }],
          class: (row.value >= 1 ? 'atingido100' : (row.value >= 0.8 ? 'atingido80' : 'nao_atingido')),
          attrs: {
            "title": '<h5>Refere-se a todas as prestações de contas registradas no SGP sobre o valor requisitado</h5>'
          }
        }, [_vm._v("\n                  " + _vm._s(_vm._f("percentage")(row.value)) + "\n                ")]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.propsLayout != 'EXECUCAO' || (_vm.formEditavel && !_vm._.has(row.item, 'requisitado'))) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
          staticClass: "btn btn-back btn-flat btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.reincluir(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Reincluir")])], 1) : _c('span', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> a parcela número ' + row.item.parcela + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing, message: 'Deseja <b>APAGAR</b> a parcela número ' + row.item.parcela + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir\n                    ")])], 1)]) : _vm._e()]
      }
    }], null, false, 96421485)
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.totais.distribuidos.misto !== 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Misto")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total do Projeto")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor adiantável da Fundação que distribuiu em <span class=\'realce\'>' + _vm.ehNulo((_vm._.countBy(_vm.table.items, function(m) {
        return ('' + m.origem) === '1'
      }))['true'], 'nenhuma') + '</span> parcela(s) acima</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.fbb)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor adiantável de Parceiros Estratégicos que distribuiu em <span class=\'realce\'>' + _vm.ehNulo((_vm._.countBy(_vm.table.items, function(m) {
        return ('' + m.origem) === '5'
      }))['true'], 'nenhuma') + '</span> parcela(s) acima</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.parceiros)))]) : _vm._e()]), _vm._v(" "), (_vm.totais.distribuidos.misto !== 0) ? _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor adiantável que pode ser usado com recursos da Fundação ou de Parceiros Estratégicos que foi distribuído em <span class=\'realce\'>' + _vm.ehNulo((_vm._.countBy(_vm.table.items, function(m) {
        return ('' + m.origem) === '0'
      }))['true'], 'nenhuma') + '</span> parcela(s) acima</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.misto)))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.total >= _vm.totais.distribuidos.total) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total adiantável que distribuiu em <span class=\'realce\'>' + (_vm.table.items.length === 0 ? 'nenhuma' : _vm.table.items.length) + '</span> parcela(s) acima</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.total)))]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "atencao",
    attrs: {
      "title": '<h5>Valor total distribuído ultrapassou o total adiantável no cronograma do projeto</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.distribuidos.total)))])])]), _vm._v(" "), (Math.trunc(_vm.totais.restantes.total + _vm.totais.residuo.total) > 0 || Math.abs((_vm.totais.restantes.total + _vm.totais.residuo.total) % 1) > 0.01 && _vm.usuarioLogado.ds_tipo_usuario === 'FUNDACAO') ? _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.restantes.fbb + _vm.totais.residuo.fbb !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "atencao",
    style: (((_vm.totais.restantes.fbb + _vm.totais.residuo.fbb) >= 0 ? 'background: steelblue !important;' : '')),
    attrs: {
      "title": '<h5>' + ((_vm.totais.restantes.fbb + _vm.totais.residuo.fbb) >= 0 ? 'Este é <u>restante</u> do valor de <span class=\'realce\'>R$ ' + (_vm.totais.projeto.fbb) + '</span> dos itens adiantáveis da Fundação' + (_vm.totais.residuo.fbb > 0 ? ' acrescido de <span class=\'realce\'>R$ ' + _vm.totais.residuo.fbb + '</span> de resíduos de parcelas não liberadas integralmente' : '') + ' que ainda podem ser lançados em parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.restantes.fbb + _vm.totais.residuo.fbb)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.restantes.parceiros + _vm.totais.residuo.parceiros !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "atencao",
    style: (((_vm.totais.restantes.parceiros + _vm.totais.residuo.parceiros) >= 0 ? 'background: steelblue !important;' : '')),
    attrs: {
      "title": '<h5>' + ((_vm.totais.restantes.fbb + _vm.totais.residuo.fbb) >= 0 ? 'Este é <u>restante</u> do valor de <span class=\'realce\'>R$ ' + (_vm.totais.projeto.parceiros) + '</span> dos itens adiantáveis de Parc Estratégicos' + (_vm.totais.residuo.parceiros > 0 ? ' acrescido de <span class=\'realce\'>R$ ' + _vm.totais.residuo.parceiros + '</span> de resíduos de parcelas não liberadas integralmente' : '') + ' que ainda podem ser lançados em parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.restantes.parceiros + _vm.totais.residuo.parceiros)))]) : _vm._e()]), _vm._v(" "), (_vm.totais.distribuidos.misto !== 0) ? _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.restantes.misto + _vm.totais.residuo.misto !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "atencao",
    style: (((_vm.totais.restantes.misto + _vm.totais.residuo.misto) >= 0 ? 'background: steelblue !important;' : '')),
    attrs: {
      "title": '<h5>' + ((_vm.totais.restantes.misto + _vm.totais.residuo.misto) >= 0 ? 'Este é <u>restante</u> do valor de <span class=\'realce\'>R$ ' + (_vm.totais.projeto.misto) + '</span> dos itens adiantáveis da Fundação e de Parc Estratégicos' + (_vm.totais.residuo.misto > 0 ? ' acrescido de <span class=\'realce\'>R$ ' + _vm.totais.residuo.misto + '</span> de resíduos de parcelas não liberadas integralmente' : '') + ' que ainda podem ser lançados em parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.restantes.misto + _vm.totais.residuo.misto)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.restantes.total + _vm.totais.residuo.total !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "atencao",
    style: (((_vm.totais.restantes.total + _vm.totais.residuo.total) >= 0 ? 'background: steelblue !important;' : '')),
    attrs: {
      "title": '<h5>' + ((_vm.totais.restantes.fbb + _vm.totais.residuo.fbb) >= 0 ? 'Este é <u>restante</u> do valor de <span class=\'realce\'>R$ ' + (_vm.totais.projeto.total) + '</span> dos itens adiantáveis do cronograma do projeto' + (_vm.totais.residuo.total > 0 ? ' acrescido de <span class=\'realce\'>R$ ' + _vm.totais.residuo.total + '</span> de resíduos de parcelas não liberadas integralmente' : '') + ' que ainda podem ser lançados em parcelas' : 'Ultrapassou o limite de valores da Fundação para distribuir em parcelas') + '</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.restantes.total + _vm.totais.residuo.total)))]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.parcela, 'parcela')),
      expression: "_.has(parcela, 'parcela')"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Parcela:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.parcela.parcela))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('origem')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "origem"
    }
  }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parcela.origem),
      expression: "parcela.origem"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.existeFaseFBB === 0 && _vm.existeFaseParc === 0,
      "name": "origem",
      "id": "origem"
    },
    on: {
      "click": _vm.verificaFase,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.parcela, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.existeFaseFBB > 0) ? _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.existeFaseParc > 0) ? _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (_vm.existeFaseParc > 0 && _vm.existeFaseFBB > 0) ? _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Misto")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.existeFaseFBB === 0 && _vm.existeFaseParc === 0),
      expression: "existeFaseFBB === 0 && existeFaseParc === 0"
    }],
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "atencao"
  }, [_vm._v("Precisa ter algum item marcado como Adiantavel no cronograma")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('valor')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valor:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:' + _vm.limiteParcela(_vm.parcela).toFixed(2)),
      expression: "'required|min_value:1|max_value:' + limiteParcela(parcela).toFixed(2)"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "valor",
      "type": "text"
    },
    model: {
      value: (_vm.parcela.valor),
      callback: function($$v) {
        _vm.$set(_vm.parcela, "valor", $$v)
      },
      expression: "parcela.valor"
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Valor máximo permitido para esta parcela: "), _c('strong', [_vm._v(_vm._s(_vm._f("real")(_vm.limiteParcela(_vm.parcela))))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "box-header"
  }, [_vm._v("\n  Não há itens adiantáveis nem parcelas cadastradas\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32e0d992!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/parcela-adiantamento.vue
// module id = 1820
// module chunks = 2